import { useEffect } from 'react'

function setMetaTag({ attr, key, value }) {
  if (!value) return
  const selector = `meta[${attr}="${key}"]`
  let tag = document.head.querySelector(selector)

  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(attr, key)
    document.head.appendChild(tag)
  }

  tag.setAttribute('content', value)
}

export function buildToolStructuredData({ name, description, category = 'EngineeringCalculator', keywords }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name,
    description,
    applicationCategory: category,
    operatingSystem: 'Web',
    inLanguage: 'pt-BR',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'BRL',
    },
    publisher: {
      '@type': 'Organization',
      name: 'Calculadoras de Engenharia',
    },
    keywords,
  }
}

export function Seo({ title, description, canonicalPath, image, type = 'website', structuredData, noIndex = false }) {
  useEffect(() => {
    const baseUrl = window.location.origin
    const canonicalUrl = canonicalPath ? new URL(canonicalPath, baseUrl).toString() : window.location.href
    const imageUrl = image ? new URL(image, baseUrl).toString() : new URL('/favicon.ico', baseUrl).toString()

    if (title) {
      document.title = title
    }

    const metaTags = [
      { attr: 'name', key: 'description', value: description },
      { attr: 'property', key: 'og:title', value: title },
      { attr: 'property', key: 'og:description', value: description },
      { attr: 'property', key: 'og:type', value: type },
      { attr: 'property', key: 'og:url', value: canonicalUrl },
      { attr: 'property', key: 'og:image', value: imageUrl },
      { attr: 'name', key: 'twitter:card', value: 'summary_large_image' },
      { attr: 'name', key: 'twitter:title', value: title },
      { attr: 'name', key: 'twitter:description', value: description },
      { attr: 'name', key: 'twitter:image', value: imageUrl },
      { attr: 'name', key: 'robots', value: noIndex ? 'noindex, nofollow' : 'index, follow' },
    ]

    metaTags.forEach(setMetaTag)

    let canonicalLink = document.head.querySelector('link[rel="canonical"]')
    if (!canonicalLink) {
      canonicalLink = document.createElement('link')
      canonicalLink.setAttribute('rel', 'canonical')
      document.head.appendChild(canonicalLink)
    }
    canonicalLink.setAttribute('href', canonicalUrl)

    const existingScript = document.getElementById('seo-structured-data')
    const structuredPayload = structuredData ? { url: canonicalUrl, ...structuredData } : null

    if (structuredPayload) {
      const scriptTag = existingScript || document.createElement('script')
      scriptTag.id = 'seo-structured-data'
      scriptTag.type = 'application/ld+json'
      scriptTag.textContent = JSON.stringify(structuredPayload)
      if (!existingScript) {
        document.head.appendChild(scriptTag)
      }
    } else if (existingScript) {
      existingScript.remove()
    }
  }, [title, description, canonicalPath, image, type, structuredData, noIndex])

  return null
}

export function CalculatorSeo({ title, description, path, keywords, image }) {
  const structuredData = buildToolStructuredData({ name: title, description, keywords })

  return (
    <Seo
      title={`${title} | Calculadoras de Engenharia`}
      description={description}
      canonicalPath={path}
      image={image}
      type="article"
      structuredData={structuredData}
    />
  )
}
